<script setup lang="ts">
import CustomCloseButton from '@/components/createdUi/CustomCloseButton.vue'
import type { IImportColumn } from '../types/IImportColumn'
import { columnLetter } from '../utils/columnLetter'

const props = defineProps<{
  modelValue: boolean
  columns: IImportColumn[]
  formats: string[]
}>()

const formatsLabel = computed(() => props.formats.join(', '))

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

function close() {
  emit('update:modelValue', false)
}
</script>

<template>
  <VDialog
    :model-value="modelValue"
    max-width="960"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <VCard class="pa-6 d-flex flex-column ga-4 bg-surface">
      <div class="d-flex align-center justify-space-between ga-3">
        <span class="text-h4 import-modal-title">Подготовка таблицы для загрузки</span>
        <CustomCloseButton :close-action="close" />
      </div>
      <p class="text-body-1 mb-0">
        Загрузите таблицу<span v-if="formatsLabel"> в формате {{ formatsLabel }}</span>. Первая строка — названия колонок, вторая — примеры значений.
      </p>
      <div v-if="columns.length" class="overflow-x-auto">
        <table class="import-plain-table">
          <thead>
            <tr>
              <th
                v-for="(column, index) in columns"
                :key="`${column.name}-${index}`"
              >
                {{ columnLetter(index) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                v-for="(column, index) in columns"
                :key="`name-${index}`"
              >
                {{ column.name }}
              </td>
            </tr>
            <tr>
              <td
                v-for="(column, index) in columns"
                :key="`example-${index}`"
              >
                {{ column.example ?? '' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="pa-4 text-medium-emphasis">
        Нет колонок в схеме
      </div>
    </VCard>
  </VDialog>
</template>

<style scoped lang="scss">
.import-modal-title {
  color: rgba(var(--v-theme-text-primary), var(--v-high-emphasis-opacity));
}

.import-plain-table {
  border-collapse: collapse;
  width: 100%;

  th {
    background-color: rgb(var(--v-theme-primary-100), var(--v-overlay-scrim-opacity));
    color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 22px;
    padding: 0.75rem 1rem;
    position: relative;
    text-align: start;
    white-space: nowrap;
  }

  td {
    color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    padding: 0.75rem 1rem;
    text-align: start;
  }

  th:not(:last-child)::after {
    background-color: rgb(var(--v-theme-on-background), var(--v-custom-opacity));
    content: '';
    height: 14px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
  }
}
</style>
